import StateType from './state.type';

export default {
  loading: false,
  products: [],
  total: 0,
  totalStock: 0,
} as StateType;
